/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateMedicaidCaseRequest
 */
export interface UpdateMedicaidCaseRequest {
    /**
     * 
     */
    expected_revision: number;
    /**
     * 
     */
    owner_user_id?: string | null;
    /**
     * 
     */
    status?: UpdateMedicaidCaseRequestStatusEnum;
}


/**
 * @export
 */
export const UpdateMedicaidCaseRequestStatusEnum = {
    Open: 'open',
    Paused: 'paused',
} as const;
export type UpdateMedicaidCaseRequestStatusEnum = typeof UpdateMedicaidCaseRequestStatusEnum[keyof typeof UpdateMedicaidCaseRequestStatusEnum];


/**
 * Check if a given object implements the UpdateMedicaidCaseRequest interface.
 */
export function instanceOfUpdateMedicaidCaseRequest(value: object): value is UpdateMedicaidCaseRequest {
    if (!('expected_revision' in value) || value['expected_revision'] === undefined) return false;
    return true;
}

export function UpdateMedicaidCaseRequestFromJSON(json: any): UpdateMedicaidCaseRequest {
    return UpdateMedicaidCaseRequestFromJSONTyped(json, false);
}

export function UpdateMedicaidCaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMedicaidCaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_revision': json['expected_revision'],
        'owner_user_id': json['owner_user_id'] === undefined ? undefined : json['owner_user_id'] === null ? null : json['owner_user_id'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function UpdateMedicaidCaseRequestToJSON(json: any): UpdateMedicaidCaseRequest {
    return UpdateMedicaidCaseRequestToJSONTyped(json, false);
}

export function UpdateMedicaidCaseRequestToJSONTyped(value?: UpdateMedicaidCaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_revision': value['expected_revision'],
        'owner_user_id': value['owner_user_id'],
        'status': value['status'],
    };
}

